module.exports = __webpack_public_path__ + "img/KC_BG3.ac68dccd.png";